function disablePayment() {
  showErrorMessages();
}
function enablePayment() {
  [...document.querySelectorAll(".product-add-to-cart-container")].forEach(
    (e) => (e.style = "")
  );
}
function getMeasureInputs() {
  return document.querySelectorAll(
    "#input-measurements-wrapper input[type='number']"
  );
}
function shouldEnable() {
  [...getMeasureInputs()].every((e) => e.value)
    ? enablePayment()
    : disablePayment();
}
function clearMeasurements() {
  getMeasureInputs().forEach((e) => {
    e.value = null;
  });
}
function addToHidden(e) {
  let t = document.querySelector('input[name="size"]:checked').value;
  document.getElementById(e.target.id + "-val").value =
    e.target.value + " " + t;
}
function unitChange() {
  let e = document.querySelector('input[name="size"]:checked').value;
  [...getMeasureInputs()].forEach(
    (t) => (document.getElementById(t.id + "-val").value = t.value + " " + e)
  );
}
function addMeasureListeners() {
  [
    ...document.querySelectorAll(
      "#input-measurements-wrapper input[type='number']"
    ),
  ].forEach((e) => {
    e.addEventListener("change", (e) => {
      addToHidden(e), shouldEnable();
    });
  });
}
function changeSelectedSizing(e) {
  try {
    if (
      "Made-to-Measure" !=
        document.getElementsByName("options[Size]")?.[0]?.value &&
      "Made-to-Measure" !=
        document.getElementsByName("options[Dress Size]")?.[0]?.value
    ) {
      enablePayment();
      clearMeasurements(),
        (document.getElementById("input-measurements-wrapper").style =
          "display:none;");
    } else {
      shouldEnable();
      document.getElementById("input-measurements-wrapper").style = "";
    }
  } catch (e) {
    console.error(e);
  }
}
function addSizeListen() {
  [...document.getElementsByName("options[Size]")].forEach((e) => {
    e.addEventListener("change", (e) => {
      changeSelectedSizing(e);
    });
  });
}

/* Start of Error Messages for Made-To-Measure */
let validationAttempted = false;

function clearErrorMessages() {
  document.querySelectorAll(".error-message").forEach((msg) => msg.remove());
  document.querySelectorAll(".size-main-validation").forEach((input) => {
    input.classList.remove("input-error");
  });
}

function showErrorMessages() {
  if (!validationAttempted) return;

  getMeasureInputs().forEach((input) => {
    const value = input.value.trim();
    const numericValue = parseFloat(value);

    if (value === "" || isNaN(numericValue) || numericValue <= 0) {
      let errorMsg = input.nextElementSibling;
      if (!errorMsg || !errorMsg.classList.contains("error-message")) {
        errorMsg = document.createElement("span");
        errorMsg.classList.add("error-message");
        errorMsg.style.color = "red";
        errorMsg.style.fontSize = "12px";
        errorMsg.textContent =
          numericValue <= 0 ? "Value must be greater than 0." : "Required";
        errorMsg.style.display = "none";
        input.parentNode.appendChild(errorMsg);
      }

      input.classList.add("input-error");
    }
  });
}

function clearErrorMessage(input) {
  const errorMsg = input.parentNode.querySelector(".error-message");
  if (errorMsg) {
    errorMsg.remove();
  }

  input.classList.remove("input-error");
}

function addInputListeners() {
  getMeasureInputs().forEach((input) => {
    input.addEventListener("input", () => {
      const value = parseFloat(input.value.trim());
      if (!isNaN(value) && value > 0) {
        clearErrorMessage(input);
      }
    });

    input.addEventListener("change", () => {
      const value = parseFloat(input.value.trim());
      if (!isNaN(value) && value > 0) {
        clearErrorMessage(input);
      }
    });
  });
}

function validateMeasurements(event) {
  debugLog("Starting measurements validation...");

  const measurementsWrapper = document.getElementById(
    "input-measurements-wrapper"
  );
  const isMeasurementsVisible =
    measurementsWrapper && measurementsWrapper.offsetParent !== null;
  debugLog("Is input-measurements-wrapper visible?", isMeasurementsVisible);

  if (!isMeasurementsVisible) {
    debugLog("Made-to-Measure mode is NOT active, skipping validation.");
    validationAttempted = false;

    getMeasureInputs().forEach((input) => {
      input.value = "";
      document.getElementById(input.id + "-val").value = "";
    });

    return true;
  }

  validationAttempted = true;

  clearErrorMessages();

  const allFilled = [...getMeasureInputs()].every((input) => {
    const numericValue = parseFloat(input.value.trim());
    const isValid = !isNaN(numericValue) && numericValue > 0;
    debugLog(`Field ${input.id}: ${input.value} (Valid: ${isValid})`);
    return isValid;
  });

  if (!allFilled) {
    debugLog("Missing or invalid values in inputs, blocking submit.");
    event.preventDefault();
    event.stopPropagation();
    showErrorMessages();

    document
      .querySelectorAll(".error-message")
      .forEach((msg) => (msg.style.display = "block"));

    return false;
  }

  debugLog("All values are valid, allowing submit.");
  validationAttempted = false;
  return true;
}

document.addEventListener("DOMContentLoaded", () => {
  const productForm = document.querySelector("form[action*='/cart/add']");
  if (productForm) {
    debugLog("Shopify form detected, adding validation.");
    productForm.addEventListener("submit", (event) => {
      const isValid = validateMeasurements(event);
      if (!isValid) {
        debugLog("Blocking form submit.");
        event.preventDefault();
        event.stopPropagation();
      }
    });
  } else {
    debugLog("No Shopify form found.");
  }

  const addToCartButtons = document.querySelectorAll(
    ".single-add-to-cart-button"
  );
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      debugLog("Click on Add to Cart, validating before submitting...");
      const isValid = validateMeasurements(event);
      if (!isValid) {
        debugLog("Blocking Add to Cart click event.");
        event.preventDefault();
        event.stopPropagation();
      }
    });
  });

  addInputListeners();
});

/* End of Error Messages for Made-To-Measure */

function moveWishList() {
  let e = setInterval(() => {
    try {
      var t = document.getElementById("widget-fave-html"),
        n = document.getElementsByClassName("variations");
      document
        .getElementById(
          "variant-selects-template--23820854067580__main-product"
        )
        .insertBefore(t, n[0]),
        clearInterval(e);
    } catch (a) {
      console.error(a);
    }
  }, 50);
}

addEventListener("DOMContentLoaded", (e) => {
  addSizeListen(), changeSelectedSizing({}), addMeasureListeners();
});
